module.exports = "md-sidenav-layout {\n  background: rgba(0, 0, 0, 0.03); }\n\n*, /deep/ * {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/layout/layout.component.scss
// module id = ./src/app/components/layout/layout.component.scss
// module chunks = main